









































import { Component, Vue, Watch } from 'vue-property-decorator';
import authModule from '@/store/Auth';

@Component({ components: {} })
export default class ConfirmDialog extends Vue {
  get dialogActive() {
    return authModule.showSubscriptionRequiredDialog !== null;
  }

  set dialogActive(v: boolean) {
    if (!v) {
      authModule.setShowSubscriptionRequiredDialog(null);
    }
  }

  get activeOrganisation() {
    if (!authModule.activeOrganisation) {
      throw new Error(
        this.$t('common.alerts.missingActiveOrganisation') as string,
      );
    }
    return authModule.activeOrganisation.organisation;
  }

  get isOwner() {
    return authModule.isOwner;
  }

  @Watch('dialogActive', { immediate: true })
  dialogActiveChanged(val: boolean) {
    if (!val) {
      this.$emit('dismiss', 'subscriptionRequired');
    }
  }
}
